import React, { Suspense } from "react";
import { connect } from "react-redux";
import { formActions } from "../../../../../../store/actions/cms/form/form.action";
import { templateActions } from "../../../../../../store/actions/cms/template/template.action";
import { DragDropContext } from "react-beautiful-dnd";
import { Container } from "reactstrap";

import {
  AppAside,
} from "@coreui/react";

//Lazy load this
import PageContent from "../Content/PageContent";
import { languageActions } from "../../../../../../store/actions/system/language/language.action";
import { arrayHelper } from "../../../../../../helpers/arrayHelper";
import Notifier from "../../../../../../components/UI/Notifier/Notifier";
import { elementConstants } from "../../../../../../constants/cms/form/element/element.constants";
import { systemLabelActions } from "../../../../../../store/actions/system/systemLabel/systemLabel.action";
import { containerHelper } from "../../../../../helpers/containerHelper";
import { content } from "../../../../../models/content";
import { contentHelper } from "../../../../../helpers/contentHelper";
import TemplateWrapper from "../../../../template/containers/TemplateLayout/TemplateWrapper";
import { cmsActions } from "../../../../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../../../../constants/cms/sourceType";
import { SplashScreen } from "../../../../../components/UI/SplashScreen/SplashScreen";
import { pageActions } from "../../../../../../store/actions/cms/page/page.action";
import "./PageLayout.css";
import "../../../../../style/EditorLayout.css";
import { deepClone } from "../../../../../../helpers/objectHelper";
import { defaultUserPageElement } from "../../../../../models/defaultElements";
import { securityHelper } from "../../../../../../helpers/securityHelper";
import EditorSidebar from "../../../../../components/editor/EditorSidebar/EditorSidebar";
import { getKey } from "../../../../../../helpers/UrlHelper";
class PageEditorLayout extends React.Component {
  state = {
    loaded: false,
    sidebarOpen: true,
    asideOpen: true,
  };
  componentDidMount() {
    const { dispatch, user, match } = this.props;
    if (user) {
      let eventId = null;
      let languageCode = null;
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        let unparsedEventId = params.get(getKey("eventId", params));
        if (unparsedEventId) eventId = parseInt(unparsedEventId)
        languageCode = params.get(getKey("languageCode", params));
      }
      if (user && !eventId) {
        eventId = user.eid === undefined ? user.token.eid : user.eid;
      }
      if (user && !languageCode) {
        languageCode = user.userLang === undefined ? user.token.userLang : user.userLang;
      }
      if (!languageCode) languageCode = "swe";
      dispatch(languageActions.getAllCodesByEvent(eventId));
      dispatch(cmsActions.setEnviroment(sourceTypes.PAGE, true, eventId, languageCode));
      dispatch(templateActions.getAll(eventId, true));

      dispatch(pageActions.getAllPaths(eventId));
      dispatch(formActions.getAllPaths(eventId));
      dispatch(systemLabelActions.getGroup(languageCode, "Page.Edit"));
      dispatch(pageActions.get(match.params.id, false));
    }
  }
  componentDidUpdate(prevProps) {
    const { page, element, template, dispatch, language } = this.props;
    const { loaded } = this.state;
    if (
      page !== undefined &&
      prevProps.page !== page &&
      template.template === undefined &&
      page.templateId
    ) {
      if (page.templateId) {
        dispatch(templateActions.get(page.templateId));

      }
      /*   dispatch(templateActions.getAll(page.eventId, true)); */
    }
    if (
      page.pageId > 0 &&
      language.loading === false &&
      template.template !== undefined &&
      loaded === false
    ) {
      this.setState({ loaded: true });
    }
  }
  sortElements = result => {
    const { destination, source, draggableId } = result;
    const { dispatch, page } = this.props;
    const newPage = deepClone(page);

    const sourceEl = newPage.pageElements.find(el => {
      return el.contentId === draggableId;
    });

    if (destination.index > source.index) {
      //if moved down
      newPage.pageElements.map(el => {
        if (
          el.page === sourceEl.page &&
          el.parentId === sourceEl.parentId &&
          el.sortOrder > source.index &&
          el.sortOrder <= destination.index
        ) {
          el.sortOrder -= 1;
        }

        if (el.contentId === sourceEl.contentId) {
          el.sortOrder = destination.index;
        }
      });
    } else if (destination.index < source.index) {
      newPage.pageElements.map(el => {
        if (
          el.page === sourceEl.page &&
          el.parentId === sourceEl.parentId &&
          el.sortOrder <= source.index &&
          el.sortOrder >= destination.index
        ) {
          el.sortOrder += 1;
        }
        if (el.contentId === sourceEl.contentId) {
          el.sortOrder = destination.index;
        }
      });
    }

    dispatch(pageActions.softUpdate(newPage));

  };
  moveElement = result => {
    const { destination, draggableId } = result;
    const { dispatch, page } = this.props;

    const elementInfo = draggableId.split(":");

    const newPage = Object.assign({}, page);
    const newPageElements = Array.from(
      arrayHelper.sortByParam(newPage.pageElements, 'sortOrder')
    );

    newPageElements.sort((a, b) => {
      let x = a.sortOrder;
      let y = b.sortOrder;
      return y < x ? 1 : y > x ? -1 : 0;
    });

    newPageElements.map(el => {
      if (
        el.sortOrder >= destination.index &&
        el.parentId === null
      )
        el.sortOrder += 1;
    });

    if (
      parseInt(elementInfo[0]) === elementConstants.CONTAINER
    ) {
      let newContainerElements = containerHelper.create(
        newPage,
        "PAGE",
        elementInfo[1],
        destination.index
      );
      newPage.pageElements = newPageElements.concat(newContainerElements);
      dispatch(pageActions.softUpdate(newPage));
      return;

    } else if (
      parseInt(elementInfo[0]) === elementConstants.CONTENT
    ) {
      const selectedEl = content.find(el => {
        return el.id === elementInfo[1];
      });

      newPageElements.map(el => {
        if (el.sortOrder > destination.index && el.page == page.currentPage && el.parentId === null)
          el.sortOrder += 1;
      })
      let element = contentHelper.create(
        newPage,
        sourceTypes.PAGE,
        selectedEl,
        destination
      );
      newPageElements.push(element);
      newPage.pageElements = newPageElements;
      dispatch(pageActions.softUpdate(newPage));
      return;
    }
    if (
      parseInt(elementInfo[0]) === elementConstants.USER_PAGE
    ) {
      const selectedEl = deepClone(defaultUserPageElement)
      const newId = newPageElements.filter(np => np.type === elementConstants.USER_PAGE).length + 1;

      newPageElements.map(el => {
        if (el.sortOrder > destination.index && el.page == page.currentPage && el.parentId === null)
          el.sortOrder += 1;
      })

      selectedEl.sortOrder = destination.index;
      selectedEl.eventId = page.eventId;
      selectedEl.parentId = null;
      selectedEl.id = newId;
      selectedEl.pageId = page.pageId;
      selectedEl.languageCode = page.languageCode;
      selectedEl.contentId = securityHelper.createGuid();
      newPageElements.push(selectedEl);
      newPage.pageElements = newPageElements;
      dispatch(pageActions.softUpdate(newPage));
      return;
    }
  };
  onDragEnd = result => {
    const { destination, source, draggableId } = result;
    const { page, dispatch } = this.props;
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    if (
      destination.droppableId === "content" &&
      source.droppableId === "content"
    ) {
      this.sortElements(result);
    }
    if (
      destination.droppableId === "content" &&
      source.droppableId.includes("sidebar")
    ) {
      this.moveElement(result);
    }
    if (
      destination.droppableId.includes("column") &&
      source.droppableId.includes("sidebar")
    ) {
      const newPage = containerHelper.addTo(
        page,
        sourceTypes.PAGE,
        page.pageElements,
        result
      );
      dispatch(pageActions.softUpdate(newPage));

      const containerId = destination.droppableId.slice(
        destination.droppableId.lastIndexOf("-") + 1,
        destination.droppableId.length + 1
      );

      dispatch(cmsActions.containerToUpdate(containerId));
    }
    if (
      destination.droppableId.includes("column") &&
      source.droppableId.includes("column") &&
      destination.droppableId === source.droppableId
    ) {
      const newPage = containerHelper.move(page, sourceTypes.PAGE, result);
      dispatch(pageActions.softUpdate(newPage));
    }
    if (
      (!source.droppableId.includes("sidebar") &&
        (destination.droppableId.includes("content") &&
          source.droppableId.includes("column"))) ||
      (destination.droppableId.includes("column") &&
        source.droppableId.includes("content")) ||
      (destination.droppableId.includes("column") &&
        source.droppableId.includes("column"))
    ) {
      const newPage = containerHelper.move(page, sourceTypes.PAGE, result);
      dispatch(pageActions.softUpdate(newPage));
    }
  };
  toggleEditor = editor => {
    this.setState({ [editor]: !this.state[editor] });
  };
  render() {
    const { alert, page } = this.props;
    const { loaded, sidebarOpen, asideOpen } = this.state;
    return (
      <React.Fragment>
        {!loaded && <SplashScreen />}
        {page ? (
          <DragDropContext
            onDragUpdate={this.onDragStart}
            onDragEnd={this.onDragEnd}
          >
            <div className="app form-editmode">
              <div className="app-body" style={{ marginTop: "0px" }} />

              <AppAside
                className="editor-aside"
                fixed
                display="lg"
                style={{ width: "320px" }}
                className={this.state.asideOpen ? "aside-show" : "aside-hide"}
              >
                <Suspense >
                  <div ref={r => this.asideEditorRef = r}>
                    <EditorSidebar
                      toggleConditionModal={this.toggleConditionModal}
                    />
                  </div>

                </Suspense>
              </AppAside>

              <main
                style={{ marginLeft: this.state.asideOpen ? "320px" : "0px" }}
                className=" not-inflicted editor-content"
              >
                <div className="animated fadeIn">
                  <Container fluid style={{ padding: "0px" }}>
                    <Suspense >
                      <TemplateWrapper>
                        <PageContent
                          sidebarRef={this.sidebarRef}
                          asideEditorRef={this.asideEditorRef}
                        />
                      </TemplateWrapper>
                    </Suspense>
                  </Container>
                </div>
              </main>
            </div>
            {alert.type ? (
              <Notifier message={alert.message} type={alert.type} />
            ) : null}
          </DragDropContext>
        ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    page: state.page,
    template: state.template,
    language: state.language,
    systemLabel: state.systemLabel
  };
}
export default connect(mapStateToProps)(PageEditorLayout);
